export interface ILogin {
  token: string
  id: number
  name: string
  email: string
  phone: string
  password: string
  profile: any
  role: number
  menu: Menu[]
  expires_at: number
}

export class Admin {
  public token: Token
  public id: number
  public name: string
  public email: string
  public phone: string
  public password: string
  public profile: any
  public role: number
  public menu: Menu[]

  constructor(
    id: number,
    name: string = '',
    email: string = '',
    phone: string = '',
    password: string = '',
    profile: any,
    role: number = 0,
    menu: Menu[],
    token: Token
  ) {
    this.id = id
    this.name = name
    this.email = email
    this.phone = phone
    this.password = password
    this.profile = profile
    this.role = role
    this.menu = menu
    this.token = token
  }
}

export class Token {
  public accessToken?: string
  public expiredAt?: number

  constructor(accessToken?: string, expiredAt?: number) {
    this.accessToken = accessToken
    this.expiredAt = expiredAt
  }
}

export class Menu {
  public description: string
  public name: string
  public permission: string

  constructor(description: string, name: string, permission: string) {
    this.description = description
    this.name = name
    this.permission = permission
  }
}
